
/**
 * 뉴스 출처 정보
 */
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroSource = {
  name?: string;
  url?: string;
};
